import { useEffect } from 'react';
import { usePermissions } from 'react-hook-use-permissions';

import { useActions } from '../store/scanSession';

const permissions = ['camera'];

export const useHandleCameraPermission = () => {
	const { hasAll } = usePermissions(permissions);
	const hasCameraPermission = hasAll(permissions);
	const actions = useActions();

	useEffect(() => {
		actions.setHasCameraPermission(hasCameraPermission);
	}, [actions, hasCameraPermission]);
};
